<template>
  <div class="public-success">
    <h6>支付成功</h6>
    <div class="content">
      <div class="icon">
        <i class="iconfont icon-icon-dengdai"></i>
      </div>
      <p>对公打款凭证已提交，待财务确认到账！</p>
      <div class="message">
        <div class="top">
          <i class="iconfont icon-icon-tishi"></i>
          <b>温馨提示:</b>
          <span>提交对公打款凭证后，海智将在48小时内确认到账。</span>
        </div>
        <div class="bottom">
          确认到账后，购买的资源包会激活生效，效期12个月。当天激活生效的资源包无法用于抵扣前一天产生的用量。如需帮助请联系400-660-5995
        </div>
      </div>

      <div class="btns">
        <el-button type="primary" @click="$router.push('/')"
          >进入控制台</el-button
        >
        <el-button @click="$router.push('/cost-center/my-order')"
          >查看我的订单</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.public-success {
  padding-top: 40px;
  > h6 {
    width: 1040px;
    margin: 0 auto;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
    margin-bottom: 20px;
  }
  > .content {
    width: 1040px;
    margin: 0 auto;
    background: #ffffff;
    padding-top: 108px;
    padding-bottom: 201px;
    .icon {
      margin: 0 auto 20px;
      width: 60px;
      height: 60px;
      background-color: #0bb976;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: rgba($color: #ff7f2a, $alpha: 0.1);
      i {
        font-size: 24px;
        color: #ff7f2a;
      }
    }
    > p {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
      text-align: center;
      margin: 16px 0 36px 0;
      height: 16px;
      line-height: 16px;
    }
    .message {
      width: 717px;
      height: 109px;
      background: #f3f5f8;
      border-radius: 4px;
      margin: 0 auto;
      padding: 28px 40px;
      box-sizing: border-box;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        height: 14px;
        > i {
          color: #ff7f2a;
          font-size: 14px;
        }
        > b {
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #ff7f2a;
          letter-spacing: 0;
          margin-left: 5px;
          margin-right: 8px;
          height: 14px;
          line-height: 14px;
        }
        > span {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181a;
          letter-spacing: 0;
          height: 14px;
          line-height: 14px;
          &::before {
            content: '*';
            color: red;
          }
        }
      }
      .bottom {
        padding-left: 88px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181a;
        letter-spacing: 0;
        line-height: 18px;
      }
    }
    .btns {
      margin-top: 36px;
      text-align: center;
      button {
        width: 200px;
        height: 40px;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
      }
      ::v-deep .el-button:last-child {
        span {
          color: #16181a;
        }
      }
    }
  }
}
</style>
